<script>
import mapi from "../mapi.js";

export default {
  // reactive state
  data() {
    return {
      show: {
        popup: false,
        notify: false,
        acc_1: false,
        acc_2: false,
        acc_3: false,
      },
      val: {
        chk_1: false,
        chk_2: false,
        chk_3: false,
      },
      first: false,
      start: false,
    }
  },
  // functions that mutate state and trigger updates
  methods: {
    allow_all() {
      this.val.chk_1 = true;
      this.val.chk_2 = true;
      this.val.chk_3 = true;
      this.save();
    },
    deny_all() {
      this.val.chk_1 = false;
      this.val.chk_2 = false;
      this.val.chk_3 = false;
      this.save();
    },
    open() {
      this.show.notify = true;
    },
    close() {
      this.show.notify = false;
    },
    openPop() {
      this.show.popup = true;
    },
    closePop() {
      this.show.popup = false;
    },
    save() {
      // 存成 cookie
      mapi.cookie("cmp_1", this.val.chk_1 ? 1 : 0, 365);
      mapi.cookie("cmp_2", this.val.chk_2 ? 1 : 0, 365);
      mapi.cookie("cmp_3", this.val.chk_3 ? 1 : 0, 365);

      this.gtag();
      this.show.popup = false;
      this.show.notify = false;
    },

    gtag() {
      let c1 = this.val.chk_1;
      let c2 = this.val.chk_2;
      let c3 = this.val.chk_3;


      gtag('consent', 'update', mapi.cmp());


    }

  },

  // lifecycle hooks
  async mounted() {
    // 讀取 cookie
    this.val.chk_1 = mapi.cookie("cmp_1") == 1;
    this.val.chk_2 = mapi.cookie("cmp_2") == 1;
    this.val.chk_3 = mapi.cookie("cmp_3") == 1;
    this.val.cmp_show = mapi.cookie("cmp_show") == 1;

    if (this.start) {
      return;
    }
    this.start = true;

    if (mapi.cookie("cmp_show") == null) {
      let ret = await mapi.queryV2({
        method: "get",
        path: "utils/cmp",
      });
      let show = true;
      try {
        show = ret['data']['show'] == 1;
      } catch (err) {

      }
      mapi.cookie("cmp_show", show ? "1" : "0", 365);
      this.val.cmp_show = show;

      if (!show) {
        mapi.cookie("cmp_1", 1, 365);
        mapi.cookie("cmp_2", 1, 365);
        mapi.cookie("cmp_3", 1, 365);
      } else {
        this.show.notify = true;
        this.first = true;
      }
    } else {
      if (mapi.cookie("cmp_1") == null) {
        this.show.notify = true;
      } else {
        this.show.notify = false;
      }
    }

    if (this.val.cmp_show) {
      // scan 所有 element , 將符合的 element 加入 觸發 cmp
      $("[data-cmp]").on("click", ()=> {
        this.openPop();
      });
      $("[data-cmp]").show();
    } else {
      $("[data-cmp]").hide();
    }
  }
}
</script>

<style>
@import "./index.css";

.fade-enter-active,
.fade-leave-active {
  transition: height 10s;
  overflow: hidden;
}

.fade-enter,
.fade-leave-to {
  height: 0;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>

<template>
  <div class="cookie_notify" v-if="show.notify">
    <el-input v-model="input" placeholder="Please input" />

    <div class="cookie_content" v-html="$t('cookie.notify.content')">

    </div>
    <div class="cookie_button">
      <button v-html="$t('cookie.btn.manager')" class="cookie_btn cookie_btn_link" id="cookie_btn_manager"
        @click="show.popup = true">

      </button>
      <button v-html="$t('cookie.btn.acceptAll')" class="cookie_btn cookie_btn_primary" id="cookie_btn_acceptAll"
        @click="allow_all">

      </button>
    </div>
  </div>
  <Transition>
    <div class="cookie_popup" v-if="show.popup">
      <div class="cookie_popup_bg"></div>
      <div class="cookie_popup_container">
        <div class="cookie_panel">
          <div class="cookie_close" @click="closePop">
            <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 18.38 18.38">
              <path
                d="M18.38,17,17,18.38,9.19,10.61,1.41,18.38,0,17,7.78,9.19,0,1.41,1.41,0,9.19,7.78,17,0l1.41,1.41L10.61,9.19Z">
              </path>
            </svg>
          </div>
          <div class="cookie_wrap" data-simplebar>
            <div class="cookie_header">
              <div class="cookie_title" v-html="$t('cookie.title_1')">
              </div>
              <div class="cookie_desc" v-html="$t('cookie.desc_1')">
              </div>
              <div class="cookie_accept">
                <button class="cookie_btn cookie_btn_primary" v-html="$t('cookie.btn.acceptAll2')"
                  id="cookie_btn_acceptAll2" @click="allow_all">
                </button>
              </div>
            </div>
            <div class="cookie_main">
              <div class="cookie_section">
                <div class="cookie_section_header">
                  <div class="cookie_title" v-html="$t('cookie.title_2')">

                  </div>
                </div>
                <div class="cookie_content">
                  <div class="cookie_desc" v-html="$t('cookie.desc_2')">
                  </div>
                </div>
              </div>
              <div class="cookie_section cookie_accordion">
                <div class="cookie_section_header">
                  <div class="cookie_title" @click="show.acc_1 = !show.acc_1">
                    <span class="cookie_plus"></span>
                    <span v-html="$t('cookie.title_3')"></span>
                  </div>
                  <div class="cookie_switch">
                    <label for="performance_cookies_setting" class="cookie_switch_label"
                      :class="{ on: val.chk_1, off: !val.chk_1 }">
                      <span class="cookie_switch_text" v-html="$t('cookie.title_3')"></span>
                      <input type="checkbox" class="cookie_switch_input" id="performance_cookies_setting"
                        v-model="val.chk_1" />
                      <div class="cookie_switch_toggle"><span></span></div>
                    </label>
                  </div>
                </div>
                <div class="cookie_desc" v-html="$t('cookie.desc_3')" v-if="show.acc_1">
                </div>
              </div>
              <div class="cookie_section cookie_accordion">
                <div class="cookie_section_header">
                  <div class="cookie_title" @click="show.acc_2 = !show.acc_2">
                    <span class="cookie_plus"></span>
                    <span v-html="$t('cookie.title_4')"></span>
                  </div>
                  <div class="cookie_switch">
                    <label for="functional_cookies_setting" class="cookie_switch_label off"
                      :class="{ on: val.chk_2, off: !val.chk_2 }">
                      <span class="cookie_switch_text" v-html="$t('cookie.title_4')"></span>
                      <input type="checkbox" class="cookie_switch_input" id="functional_cookies_setting"
                        v-model="val.chk_2" />
                      <div class="cookie_switch_toggle"><span></span></div>
                    </label>
                  </div>
                </div>
                <div class="cookie_desc" v-html="$t('cookie.desc_4')" v-if="show.acc_2">

                </div>
              </div>
              <div class="cookie_section cookie_accordion">
                <div class="cookie_section_header">
                  <div class="cookie_title" @click="show.acc_3 = !show.acc_3">
                    <span class="cookie_plus"></span>
                    <span v-html="$t('cookie.title_5')"></span>
                  </div>
                  <div class="cookie_switch">
                    <label for="markeging_cookies_setting" class="cookie_switch_label off"
                      :class="{ on: val.chk_3, off: !val.chk_3 }">
                      <span class="cookie_switch_text" v-html="$t('cookie.title_5')"></span>
                      <input type="checkbox" class="cookie_switch_input" id="markeging_cookies_setting"
                        v-model="val.chk_3" />
                      <div class="cookie_switch_toggle"><span></span></div>
                    </label>
                  </div>
                </div>
                <div class="cookie_desc" v-html="$t('cookie.desc_5')" v-if="show.acc_3">
                </div>
              </div>
            </div>
          </div>

          <div class="cookie_footer">
            <button class="cookie_btn cookie_btn_secondary" v-html="$t('cookie.btn.refuseAll')" id="cookie_btn_refuseAll"
              @click="deny_all">
            </button>
            <button class="cookie_btn cookie_btn_primary" v-html="$t('cookie.btn.confirm')" id="cookie_btn_confirm"
              @click="save">
            </button>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>